import React, { useEffect } from "react";
import {  useGoogleLogin } from "@react-oauth/google";
import { FcGoogle } from "react-icons/fc";
import { useDispatch, useSelector } from "react-redux";
import { googleLogin, logout } from "../features/social/googleSlice"; // Import actions
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function GoogleLoginButton() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { profile, error, loading } = useSelector(
    (state) => state.googleAuth
  );

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => {
      const accessToken = codeResponse.access_token;
      dispatch(googleLogin(accessToken));
    },
    onError: (error) => {
      toast.error("Login Failed: " + error.message);
    },
  });

  useEffect(() => {
    if (localStorage.getItem("isLoggedIn") === "true") {
      navigate("/");
    }
  });

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  return (
    <div>
      {loading && <p>Loading...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      {profile ? (
        <div className="d-none">
          <p>Name: {profile.name}</p>
          <br />
          <br />
          <button onClick={handleLogout}>Log out</button>
        </div>
      ) : (
        <button onClick={() => login()} className="btn btn-outline-Google">
          <FcGoogle className="me-2" />
          Sign up with Google
        </button>
      )}
    </div>
  );
}

export default GoogleLoginButton;




// import React, { useState, useEffect, useCallback } from "react";
// import { googleLogout, useGoogleLogin } from "@react-oauth/google";
// import axios from "axios";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import { FcGoogle } from "react-icons/fc";

// function GoogleLoginButton() {
//   const [user, setUser] = useState(null);
//   const [profile, setProfile] = useState(null);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   const login = useGoogleLogin({
//     onSuccess: (codeResponse) => setUser(codeResponse),
//     onError: (error) => {
//       setError("Login Failed: " + error.message);
//     },
//   });

//   const handleSubmit = useCallback(async (userData) => {
//     const data = {
//       email: userData.email,
//       name: userData.name,
//       socialID: userData.id,
//       socialType: "google",
//     };

//     var config = {
//       method: "post",
//       maxBodyLength: Infinity,
//       url: "http://18.233.85.48:8080/api//social/login",
//       headers: {
//         "Content-Type": "application/json",
//         Accept: "application/json",
//       },
//       data: JSON.stringify(data),
//     };

//     try {
//       const response = await axios(config);
//       console.log(JSON.stringify(response.data));

//       // Save token to localStorage
//       if (response.data && response.data.token) {
//         localStorage.setItem("token", response.data.token);
//       }

//       toast.success("Successful");
//       navigate("/");
//     } catch (error) {
//       console.log(error);
//       toast.error("Failed " + error.message);
//     }
//   }, [navigate]);

//   useEffect(() => {
//     if (user && user.access_token) {
//       const fetchProfileData = async () => {
//         try {
//           const res = await axios.get(
//             `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`
//           );
//           setProfile(res.data);

//           // Call the social login API here
//           if (res.data && res.data.email) {
//             handleSubmit(res.data);
//           }
//         } catch (err) {
//           setError("Google API Error: " + err.message);
//         }
//       };
//       fetchProfileData();
//     }
//   }, [user, handleSubmit]);

//   useEffect(() => {
//     if (localStorage.getItem("isLoggedIn") === "true") {
//       navigate("/");
//     }
//   }, [navigate]);

//   useEffect(() => {
//     // Save the name to local storage
//     if (profile && profile.name) {
//       localStorage.setItem("isLoggedIn", "true");
//       localStorage.setItem("name", profile.name);
//     }
//   }, [profile]);

//   const logOut = () => {
//     localStorage.removeItem("isLoggedIn");
//     localStorage.removeItem("name");
//     localStorage.removeItem("token"); // Remove token on logout
//     navigate("/login");
//     googleLogout();
//     setProfile(null);
//     setError(null);
//   };

//   return (
//     <div>
//       {error && <p style={{ color: "red" }}>{error}</p>}
//       {profile ? (
//         <div className="d-none">
//           <p>Name: {profile.name}</p>
//           <br />
//           <br />
//           <button onClick={logOut}>Log out</button>
//         </div>
//       ) : (
//         <button onClick={() => login()} className="btn btn-outline-Google">
//           <FcGoogle className="me-2" />
//           Sign in with Google
//         </button>
//       )}
//     </div>
//   );
// }

// export default GoogleLoginButton;
